import {HttpTransportType, HubConnectionBuilder, LogLevel,} from "@microsoft/signalr";
import * as Constants from "common/helpers/constants";
import reduxSignalRMiddleware, {withCallbacks,} from "common/realtime/redux-signalr-middleware";
import Guid from "common/values/guid/guid";
import MessageAPIResponse from "messaging/entities/message/api/response-contracts/message-api-response";
import {addMessage, removeMessage} from "messaging/entities/message/store/messages-redux-slice";
import Session from "users/session/session";

export const messageHubConnection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Debug)
  .withUrl(`${Constants.apiBaseUrl}/messageHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => {
      return new Promise<string>((resolve, reject) => {
        const authToken = Session.loadFromStorage(() => {
        }).authToken?.value
        if (authToken) {
          resolve(authToken)
        } else {
          reject(new Error('No token found'))
        }
      });
    }
  })
  .withAutomaticReconnect()
  .build();

const toMessage = (payload: unknown) =>
  Object.assign(new MessageAPIResponse(), payload as object).deserialize();

const callbacks = withCallbacks()
  .add("message-received", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    dispatch(addMessage(message));
  })
  .add("message-deleted", (payload: unknown) => (dispatch) => {
    const id = new Guid((payload as { id: string }).id);
    dispatch(removeMessage(id));
  });

export const messagesSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: messageHubConnection,
  shouldConnectionStartImmediately: true
});
